import Button from "@/shared/form/button";
import { UploadOutlined } from "@ant-design/icons";
import { Form, Upload, UploadProps } from "antd";
import { UploadChangeParam } from "antd/es/upload";
import { UploadFileStatus } from "antd/es/upload/interface";
import { useEffect } from "react";
import { useTranslations } from "use-intl";
import { v4 } from "uuid";

type UploadInputProps = UploadProps & {
  value?: UploadChangeParam;
  name: string;
};

export function UploadInput({
  value,
  onChange,
  name,
  ...rest
}: UploadInputProps) {
  const t = useTranslations("Feedback");
  const form = Form.useFormInstance();

  useEffect(() => {
    const eventHandler = (event: ClipboardEvent): void => {
      const file = event.clipboardData?.files[0];

      if (!file) {
        return;
      }

      const uid = v4();
      const value = form.getFieldValue(name);

      const fileObject = {
        uid,
        name: `${uid}-${file.name}`,
        status: "done" as UploadFileStatus,
      };

      onChange?.({
        file: fileObject,
        fileList: [
          ...(value?.fileList || []),
          {
            ...fileObject,
            originFileObj: file,
          },
        ],
      });
    };

    window.addEventListener("paste", eventHandler);

    return () => window.removeEventListener("paste", eventHandler);
  }, [form, name, onChange]);

  return (
    <Upload
      fileList={value?.fileList}
      beforeUpload={() => false}
      onChange={onChange}
      className="[&_.ant-upload]:!block"
      {...rest}
    >
      <Button block icon={<UploadOutlined />}>
        {t("FEEDBACK_FORM_ATTACHMENTS_LABEL")}
      </Button>
    </Upload>
  );
}
